// Fragment "money labels (N6)" — merged by ./index.js.
//
// Two rules, one theme: a money figure must name WHOSE money it is, and a price that
// does not exist must not be printed as a number.
//
//  - Tenant 360 printed ONE figure labelled "Revenue 30d" that was the subscription
//    invoice the practice pays Solunary — its own business read as its supplier's bill.
//  - A currency with no price rendered "0 /mo", for a plan the till refuses to sell
//    (400 "Plan not available in USD."). The plan tile no longer reads the plan grid at
//    all: it prints the practice's charge (`t360f.planPrice.*`, S6 contract 1.7).
//
// `t360.revenue30d` in base.js is the retired label; it is deliberately NOT redefined
// here (mergeFragments throws on a duplicate key).
export default {
  fr: {
    "t360.rev.toPlatform": "Versé à Solunary · 30 j",
    "t360.rev.toPlatformHint": "Abonnement et facturation plateforme",
    "t360.rev.clientSales": "Ventes clients · 30 j",
    "t360.rev.clientSalesHint": "Ce que ses propres clients lui ont payé, net des remboursements",
    "t360.rev.none": "Aucun",
    // PlansManager — « actif » ne veut pas dire « visible partout » : la grille
    // publique n'affiche un plan que dans les devises où il a un prix mensuel.
    "plans.publicIn": "Grille publique : visible en {shown} · masqué en {hidden}",
    "plans.publicInAll": "Grille publique : visible dans toutes les devises.",
  },
  en: {
    "t360.rev.toPlatform": "Paid to Solunary · 30d",
    "t360.rev.toPlatformHint": "Subscription and platform billing",
    "t360.rev.clientSales": "Client sales · 30d",
    "t360.rev.clientSalesHint": "What their own clients paid them, net of refunds",
    "t360.rev.none": "None",
    // PlansManager — "active" does not mean "visible everywhere": the public grid
    // lists a plan only in the currencies it has a monthly price in.
    "plans.publicIn": "Public grid: listed in {shown} · hidden in {hidden}",
    "plans.publicInAll": "Public grid: listed in every currency.",
  },
  es: {
    "t360.rev.toPlatform": "Pagado a Solunary · 30 d",
    "t360.rev.toPlatformHint": "Suscripción y facturación de la plataforma",
    "t360.rev.clientSales": "Ventas a clientes · 30 d",
    "t360.rev.clientSalesHint": "Lo que sus propios clientes le pagaron, neto de reembolsos",
    "t360.rev.none": "Ninguno",
    // PlansManager — "activo" no significa "visible en todas partes".
    "plans.publicIn": "Grilla pública: visible en {shown} · oculto en {hidden}",
    "plans.publicInAll": "Grilla pública: visible en todas las monedas.",
  },
};
